/**
 * Service for handling outgoing webhooks
 */

export const sendWebhook = async (url, event, payload, secret) => {
  console.log(`🚀 [Webhook Service] Triggering ${event} to ${url}`);
  
  const headers = {
    'Content-Type': 'application/json',
    'X-HMS-Event': event,
    'X-HMS-Signature': secret ? `sha256=${secret}` : undefined, // Simulated signature
    'User-Agent': 'HMS-Varsling-Webhook/1.0'
  };

  const body = JSON.stringify({
    id: `evt_${Date.now()}`,
    event: event,
    created_at: new Date().toISOString(),
    data: payload
  });

  try {
    // In a real production environment, this would be a real fetch.
    // For this browser-based demo, we simulate the network request 
    // to avoid CORS errors with random URLs.
    
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 800));

    // Simulate success/failure (90% success)
    const success = Math.random() > 0.1;

    if (success) {
      console.log(`✅ [Webhook Service] Successfully sent to ${url}`, { headers, body });
      return { success: true, status: 200, statusText: 'OK' };
    } else {
      console.error(`❌ [Webhook Service] Failed to send to ${url}`);
      return { success: false, status: 500, statusText: 'Internal Server Error' };
    }

    /* 
    // Real implementation:
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body
    });
    return {
      success: response.ok,
      status: response.status,
      statusText: response.statusText
    };
    */

  } catch (error) {
    console.error(`❌ [Webhook Service] Network error for ${url}`, error);
    return { success: false, error: error.message };
  }
};

export const generateWebhookSecret = () => {
  return 'whsec_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};